import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
import { Link } from "@/components/common/Link";
const industries = [{
  id: "01",
  title: "Technology",
  description: "Translating complex SaaS capabilities and B2B software solutions into clear, compelling value propositions that drive adoption."
}, {
  id: "02",
  title: "Insurance",
  description: "Demystifying risk management and policy details with precise, compliant messaging that builds trust and authority."
}, {
  id: "03",
  title: "eCommerce",
  description: "Crafting high-converting product narratives and DTC brand stories that resonate with customers and fuel sales growth."
}];
export default function NicheExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="niche-expertise" ref={ref} className="bg-background py-24 sm:py-32 relative overflow-hidden">
      <div className="container mx-auto px-6">
        <div className={cn("mb-16 max-w-2xl transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl font-sans mb-4">
            Niche Expertise
          </h2>
          <p className="text-lg text-muted-foreground font-serif">
            Specialized knowledge tailored to industries where clarity is currency.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {industries.map((industry, i) => <div key={industry.id} data-index={i} className={cn("group relative h-full transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <Card className="relative h-full overflow-hidden border border-border bg-card transition-colors duration-300 hover:border-accent/50">
                {}
                <div className="absolute inset-0 z-0 bg-gradient-to-t from-accent/40 via-accent/10 to-transparent opacity-0 transition-all duration-500 ease-out group-hover:translate-y-0 group-hover:opacity-100 translate-y-full" />

                <CardContent className="relative z-10 flex h-full flex-col items-center justify-center px-8 py-16 text-center">
                  {}
                  <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 font-serif text-[10rem] leading-none text-muted/40 select-none pointer-events-none transition-transform duration-500 group-hover:scale-110 group-hover:text-accent/10">
                    {industry.id}
                  </span>

                  {}
                  <div className="relative z-10 space-y-4">
                    <h3 className="font-sans text-2xl font-bold tracking-tight text-foreground group-hover:text-primary transition-colors duration-300">
                      {industry.title}
                    </h3>
                    <p className="font-serif text-muted-foreground leading-relaxed group-hover:text-foreground/80 transition-colors duration-300">
                      {industry.description}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}